import getPlusXMiceId from './getPlusXMiceId';
import savePlusXMiceId from './savePlusXMiceId';

export default {
  getPlusXMiceId,
  savePlusXMiceId,
};
